import React from 'react';
import {Typography} from '../typography';
import {Box, AnimatedBox} from '../box';
import {useNFTTrackCardAnimation} from '../nft-track-card/useNFTTrackCardAnimation';
import {ArtistCardProps} from './types';

export const ArtistCard: React.FC<ArtistCardProps> = ({
  src,
  artistName,
  artistHandle,
  numOfCollections,
}) => {
  const {hoveredStyle, events} = useNFTTrackCardAnimation();

  return (
    <AnimatedBox
      {...events}
      bg="surfaceDark"
      width="100%"
      style={hoveredStyle}
      overflow="hidden"
    >
      <Box borderBottomStyle="solid" borderWidth="one" borderColor="outlines">
        <Box style={{paddingTop: '100%'}}>
          <Box
            w="100%"
            position="absolute"
            top={0}
            bottom={0}
            borderRadius="circle"
            borderColor="outlines"
            borderStyle="solid"
            borderWidth="one"
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition="center"
            css={{
              backgroundImage: `url(${src})`,
            }}
          />
        </Box>
      </Box>
      <Box padding="s">
        <Box mb="one">
          <Typography color="textDefault" textStyle="s">
            {artistName}
          </Typography>
        </Box>
        <Box mb="one">
          <Typography color="textLow" textStyle="s">
            {artistHandle}
          </Typography>
        </Box>
        <Box>
          <Typography color="textLow" textStyle="s">
            {numOfCollections} collection
            {Number(numOfCollections) === 1 ? '' : 's'}
          </Typography>
        </Box>
      </Box>
    </AnimatedBox>
  );
};
